import React, { useEffect, useState } from "react";
import { getAllItems, updateItem } from "../../actions/itemActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import defaultPic from "../../assets/img/dummy.jpeg";

const AdminItemEditModal = ({
  openEditCategoryModal,
  showEditCategoryModal,
  current,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const categories = useSelector((state) => state.categories);
  const [values, setValues] = useState({
    _id: "",
    categoryId: "",
    subCategoryId: "",
    name: "",
    sellPrice: "",
    realPrice: "",
    discount: "",
    expiryDate: "",
    status: "",
    stock: "",
    // kind: Joi.string(),
    measuringUnit: "",
    descriptions: "",
    keyFeatures: "",
    disclaimer: "",
    coverImg: "",
    itemPic: "",
  });
  // console.log(values, "val edit modal k andr");
  // console.log(current, "cur edit modal k andr");
  const handleChange = (fieldName) => (event) => {
    setValues({
      ...values,
      [fieldName]: event.target.value,
    });
  };

  const currentCate = async () => {
    try {
      setValues({
        id: "",
        categoryId: "",
        subCategoryId: "",
        name: "",
        sellPrice: "",
        realPrice: "",
        discount: "",
        expiryDate: "",
        status: "",
        stock: "",
        // kind: Joi.string(),
        measuringUnit: "",
        descriptions: "",
        keyFeatures: "",
        disclaimer: "",
        coverImg: "",
        itemPic: "",
      });
      setValues({
        id: current.id,
        categoryId: current.categoryId,
        subCategoryId: current.subCategoryId,
        name: current.name,
        sellPrice: current.sellPrice,
        realPrice: current.realPrice,
        discount: current.discount,
        expiryDate: current.expiryDate,
        status: current.status,
        stock: current.stock,
        // kind: Joi.string(),
        measuringUnit: current.measuringUnit,
        descriptions: current.descriptions,
        keyFeatures: current.keyFeatures,
        disclaimer: current.disclaimer,
        coverImg: current.coverImg,
        itemPic: current.itemPic,
      });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    currentCate();
  }, [current]);

  const categoriesData = {
    _id: values.id,
    name: values.name,
    // status: values.status,
    categoryId: values.categoryId,
    subCategoryId: values.subCategoryId,
    name: values.name,
    sellPrice: values.sellPrice,
    realPrice: values.realPrice,
    discount: values.discount,
    expiryDate: values.expiryDate,
    status: values.status,
    stock: values.stock,
    // kind: Joi.string(),
    measuringUnit: values.measuringUnit,
    descriptions: values.descriptions,
    keyFeatures: values.keyFeatures,
    disclaimer: values.disclaimer,
    coverImg: values.coverImg,
    itemPic: values.itemPic,
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    for (let key of Object.keys(categoriesData)) {
      if (categoriesData[key] === "") {
        delete categoriesData[key];
      }
    }
    dispatch(updateItem(categoriesData));
    setTimeout(() => {
      // if (userData.isDriver === true) {
      dispatch(getAllItems());
      // }
    }, 1000);
    openEditCategoryModal();
  };
  return (
    <>
      {showEditCategoryModal && (
        <div
          className={`modal fade ${
            showEditCategoryModal === true ? "show" : "hide"
          }`}
          id="addnewModal"
          tabIndex="-1"
          aria-labelledby="addnewModalLabel"
          // aria-hidden="true"
          onClick={(e) => {
            // Check if the click occurred outside the modal content
            if (e.target === e.currentTarget) {
              openEditCategoryModal(); // Call your close modal function
            }
          }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="addnewModalLabel">
                  Edit
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => openEditCategoryModal()}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <fieldset>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-center mb-3">
                          <label
                            className="avatar avatar-xxl profile-cover-avatar m-0 m-auto"
                            // htmlFor="avatar_upload"
                          >
                            <img
                              className="rounded border shadow-sm"
                              src={defaultPic}
                              alt="picture"
                            />
                            <input
                              type="file"
                              id="avatar_upload"
                              className="d-none"
                              accept=".jpg, .jpeg, .png, .bmp"
                            />
                            <span className="avatar-edit">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-edit-2 avatar-uploader-icon shadow-soft"
                              >
                                <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                              </svg>
                            </span>
                          </label>
                          <p
                            className="fw-light text-info"
                            style={{ fontSize: "12px" }}
                          >
                            .jpg, .jpeg, .png, .bmp recommended size (512 X 512)
                            pixels
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="fName">Category Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="fName"
                            placeholder="Category Name"
                            value={values.name}
                            // onChange={handleChange}
                            onChange={handleChange("name")}
                          />
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                      onClick={() => openEditCategoryModal()}
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Save changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminItemEditModal;
